// extracted by mini-css-extract-plugin
export default {"preview":"Color_preview__WckbR"};